export class ScheduleFieldsDTOForSchedule{
  public status?:string
  public item_no?:string
  public delivery_date?:string
  public quantity?:string
}

export class PoFieldsDTOForSchedule{
  public poagreement_no?:string
  public vendor_code?:string

}
export class ItemFieldsDTOForSchedule{
  public uom?:string
  public material_code?:string
  public description?:string
}
